import { useState } from 'react';

export function Testimonials() {
  const testimonials = [
    {
      text: 'A terapia transformou completamente minha forma de lidar com a ansiedade. O ambiente é incrivelmente acolhedor e me sinto segura para compartilhar tudo. Em poucas semanas já percebi mudanças significativas no meu dia a dia.',
      author: 'Ana Paula, 32 anos',
      role: 'Terapia Individual'
    },
    {
      text: 'Meu relacionamento estava em crise e não sabíamos mais como nos comunicar. A terapia de casal nos ajudou a nos reconectar e entender melhor um ao outro. Hoje somos mais unidos e felizes.',
      author: 'Carlos e Marina',
      role: 'Terapia de Casal'
    },
    {
      text: 'Estava passando por um momento muito difícil na adolescência. A psicóloga me ajudou a entender meus sentimentos e a lidar melhor com as pressões da escola e da família. Me sinto muito mais confiante agora.',
      author: 'Júlia, 17 anos',
      role: 'Terapia para Adolescentes'
    },
    {
      text: 'O que mais me impressionou foi o suporte fora das sessões. Sempre que precisei, recebi orientações que me ajudaram a não desistir nos momentos difíceis. Esse acompanhamento contínuo fez toda a diferença na minha jornada.',
      author: 'Roberto, 45 anos',
      role: 'Terapia Individual'
    },
    {
      text: 'As reflexões que tive durante as sessões foram profundas demais! Consegui entender padrões de comportamento que carregava há anos. Em apenas 6 sessões, já estava me sentindo uma pessoa completamente diferente.',
      author: 'Fernanda, 28 anos',
      role: 'Terapia Individual'
    },
    {
      text: 'Nunca imaginei que terapia pudesse trazer resultados tão rápidos. Na terceira sessão já comecei a perceber mudanças reais no meu comportamento e na forma como lidava com conflitos no trabalho.',
      author: 'Marcelo, 38 anos',
      role: 'Terapia Individual'
    },
    {
      text: 'O nível de profundidade das conversas me surpreendeu. Cada sessão era uma descoberta sobre mim mesma. A psicóloga tem uma habilidade incrível de fazer as perguntas certas que me levavam a reflexões transformadoras.',
      author: 'Beatriz, 41 anos',
      role: 'Terapia Individual'
    },
    {
      text: 'Estava cético sobre terapia, mas decidi tentar. Em menos de um mês já estava dormindo melhor, mais tranquilo e conseguindo lidar com o estresse de forma saudável. Os resultados vieram muito mais rápido do que eu esperava.',
      author: 'Diego, 35 anos',
      role: 'Terapia Individual'
    },
    {
      text: 'O suporte entre as sessões foi essencial para mim. Saber que tinha alguém disponível nos momentos de crise me deu segurança para enfrentar situações que antes me paralisavam. Isso acelerou muito minha evolução.',
      author: 'Camila, 30 anos',
      role: 'Terapia Individual'
    },
    {
      text: 'As reflexões que surgiram nas sessões mudaram completamente minha perspectiva de vida. Entendi coisas sobre mim que nunca tinha percebido. Foi como acender uma luz em um quarto escuro.',
      author: 'Lucas, 26 anos',
      role: 'Terapia Individual'
    },
    {
      text: 'Fiquei impressionada com a rapidez dos resultados. Já na segunda sessão comecei a aplicar as técnicas no meu dia a dia e vi mudanças imediatas na minha ansiedade. Em 5 sessões, minha vida já estava muito melhor.',
      author: 'Patrícia, 33 anos',
      role: 'Terapia Individual'
    },
    {
      text: 'A transformação que vivi foi incrível. Cheguei na terapia perdida e em poucas sessões já tinha clareza sobre meus objetivos e sobre quem eu realmente sou. O processo foi intenso, profundo e extremamente eficaz.',
      author: 'Renata, 29 anos',
      role: 'Terapia Individual'
    },
    {
      text: 'O acompanhamento fora das sessões me salvou em momentos críticos. Poder contar com esse suporte contínuo fez com que eu não desistisse do processo e conseguisse superar obstáculos que pareciam impossíveis.',
      author: 'André, 42 anos',
      role: 'Terapia Individual'
    },
    {
      text: 'Cada sessão era uma jornada de autoconhecimento profundo. As reflexões que tive me ajudaram a ressignificar traumas antigos e a construir uma nova narrativa sobre minha vida. Sou grata por cada conversa.',
      author: 'Mariana, 36 anos',
      role: 'Terapia Individual'
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="depoimentos" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-2">
            <div className="rounded-[32px] overflow-hidden shadow-xl">
              <img
                src="https://public.readdy.ai/ai/img_res/c9e0fe3945e685635722d51aa5a65016.jpg"
                alt="Ambiente da Sala de Terapia"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:col-span-3">
            <span className="text-[#6B6B6B] text-sm mb-4 block">
              (Depoimentos)
            </span>
            <h2 className="text-4xl lg:text-5xl font-bold mb-12" style={{ fontFamily: 'Inter, sans-serif' }}>
              <span className="text-[#2C2C2C]">O Que Pacientes</span>
              <br />
              <span className="text-[#B0B0B0]">Dizem Sobre a Terapia</span>
            </h2>

            <div className="mb-8">
              <p className="text-xl text-[#2C2C2C] leading-relaxed mb-6 italic">
                "{testimonials[currentIndex].text}"
              </p>
              <div className="flex items-center gap-2">
                <div className="w-12 h-0.5 bg-[#7DD3C0]"></div>
                <div>
                  <p className="font-bold text-[#2C2C2C]">{testimonials[currentIndex].author}</p>
                  <p className="text-sm text-[#6B6B6B]">{testimonials[currentIndex].role}</p>
                </div>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <button
                onClick={prevTestimonial}
                className="w-12 h-12 flex items-center justify-center rounded-full border-2 border-[#E5E5E5] text-[#6B6B6B] hover:border-[#7DD3C0] hover:text-[#7DD3C0] transition-all duration-300 cursor-pointer"
              >
                <i className="ri-arrow-left-line text-xl"></i>
              </button>
              <button
                onClick={nextTestimonial}
                className="w-12 h-12 flex items-center justify-center rounded-full bg-[#7DD3C0] text-white hover:bg-[#6BC4B0] transition-all duration-300 cursor-pointer"
              >
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
              <div className="flex items-center gap-2 ml-4">
                {testimonials.map((_, index) => (
                  <div
                    key={index}
                    className={`h-2 rounded-full transition-all duration-300 ${
                      index === currentIndex ? 'w-8 bg-[#7DD3C0]' : 'w-2 bg-[#E5E5E5]'
                    }`}
                  ></div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}